import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Wordmark } from '@/components/layout/Wordmark';
import { LocaleToggle } from '@/components/LocaleToggle';
import { Card, CardContent } from '@/components/ui/card';

/**
 * The frame Sign in and Sign up share (UX audit, portal-signin H2 and portal-signup H3): the column is
 * anchored at the same distance from the top on both screens, so the card no longer jumps when the visitor
 * moves between them; the tagline sits under the wordmark instead of taking the card's subtitle; the link
 * to the other screen sits under the card.
 */
export function AuthFrame({ children, footer }: { children: React.ReactNode; footer?: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-full justify-center bg-canvas p-6 sm:pt-[18vh]">
      <div className="w-full max-w-md">
        <div className="mb-5 flex items-center justify-between gap-4">
          <div className="min-w-0">
            <Wordmark tone="canvas" />
            <p data-testid="auth-tagline" className="mt-1 pl-14 text-xs text-ink-secondary">
              {t('brand.tagline')}
            </p>
          </div>
          <LocaleToggle />
        </div>
        <Card>
          <CardContent className="p-6 sm:p-8">{children}</CardContent>
        </Card>
        {footer && <div className="mt-5 text-center text-base text-ink-secondary">{footer}</div>}
      </div>
    </div>
  );
}
